import { useState } from 'react'
import HtmlRendererComponent from '../html-renderer/html-renderer.component'
import './events-list.component.css'
import { closeIcon } from '../../icons'
import { Portal } from 'react-portal'
import Utils from '../../../utils'
import API from '../../../api'
import moment from 'moment'

const EventsListComponent = (props) => {
  const { restaurant } = props
  const [showRegister, setShowRegister] = useState()
  const [user, setUser] = useState({
    email: '',
    name: '',
    arrivalTime: '',
    numberOfAttendees: 1,
  })
  const [error, setError] = useState()
  const [loading, setLoading] = useState()
  const [res, setRes] = useState()

  const handleOpen = (e) => {
    setShowRegister(e)
  }

  const handleClose = () => {
    setShowRegister(false)
    setUser({ email: '', name: '', arrivalTime: '', numberOfAttendees: 1 })
    setRes(false)
    setError(false)
  }

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value })
  }

  const handleSubmit = async () => {
    try {
      setLoading(true)
      setRes(false)
      setError(false)

      // Validate email
      const valid = Utils.validateEmail(user.email)
      if (!valid) {
        setError('Please enter a valid email.')
        return
      }

      const res = await API.postContent(`events/${showRegister.id}`, user)
      setRes(res)
    } catch (e) {
      setError('Please double check you have not registered already.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="prg-events-list">
      {showRegister && (
        <Portal>
          <div className="prg-register-modal">
            <div
              className="prg-register-modal-container"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="prg-register-modal-close"
                onClick={handleClose}
              >
                {closeIcon}
              </button>
              <h2>{showRegister.title}</h2>
              <h3>{moment(showRegister.date).format('MM/DD/YYYY')}</h3>
              {res && (
                <div>
                  <h3>All set.</h3>
                  <p>Thanks for registering! We look forward to seeing you.</p>
                  <button className="prg-primary-btn" onClick={handleClose}>
                    Done
                  </button>
                </div>
              )}
              {!res && (
                <div>
                  <p>
                    Registration is free! Please fill out the following fields
                    to complete your registration:
                  </p>
                  <h5>Your Full Name:</h5>
                  <input
                    type="text"
                    name="name"
                    placeholder="My name..."
                    value={user.name}
                    onChange={handleChange}
                  />
                  <h5>Your Email:</h5>
                  <input
                    type="email"
                    name="email"
                    placeholder="My email..."
                    value={user.email}
                    onChange={handleChange}
                  />
                  <h5>Number of attendees (including yourself):</h5>
                  <input
                    type="number"
                    name="numberOfAttendees"
                    placeholder="# attendees..."
                    value={user.numberOfAttendees}
                    onChange={handleChange}
                  />
                  {showRegister.enableRegistrationArrivalTime && (
                    <>
                      <h5>
                        Estimated time of arrival (
                        {showRegister.arrivalTimeRange}):
                      </h5>
                      <input
                        type="text"
                        name="arrivalTime"
                        placeholder="My estimated time of arrival..."
                        value={user.arrivalTime}
                        onChange={handleChange}
                      />
                    </>
                  )}
                  <p>
                    <button
                      className="prg-primary-btn"
                      onClick={handleSubmit}
                      disabled={!user.name || !user.email || loading}
                    >
                      {!loading ? 'Register' : 'Submitting...'}
                    </button>
                  </p>
                  {error && (
                    <h6 className="prg-error">
                      Uh oh. There was an error registering. {error}
                    </h6>
                  )}
                </div>
              )}
            </div>
          </div>
        </Portal>
      )}
      <ul className="prg-events-list-container">
        {restaurant.events?.map((e) => {
          const {
            id,
            date,
            title,
            description,
            media,
            enableRegistrations,
            useExternalRegistrationLink,
          } = e
          const isPrior = moment().isBefore(moment(date))
          return (
            <li key={id}>
              {title && <h2>{title}</h2>}
              {date && <h3>{moment(date).format('MM/DD/YYYY')}</h3>}
              {media && (
                <img src={API.getOptimizedImage(media)} alt={media.altText} />
              )}
              <p>
                {description && <HtmlRendererComponent copy={description} />}
              </p>
              {enableRegistrations && isPrior && (
                <button
                  className="prg-primary-btn"
                  onClick={() => handleOpen(e)}
                >
                  Register Now
                </button>
              )}
              {useExternalRegistrationLink && (
                <a
                  className="prg-primary-btn"
                  target="_blank"
                  rel="noreferrer"
                  href={useExternalRegistrationLink}
                >
                  Register Now
                </a>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default EventsListComponent
